// extracted by mini-css-extract-plugin
export var container = "index-module--container--1TK4P";
export var title = "index-module--title--21mNY";
export var form = "index-module--form--1n1BM";
export var recaptchaWrapper = "index-module--recaptcha-wrapper--3RONl";
export var getEth = "index-module--get-eth--3AyLq";